<template>
  <div
    id="trainee-registration-modal"
    class="modal fade trainee-registration-modal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content modal-borderless">
        <div v-if="isLoaded">
          <ValidationObserver ref="observer">
            <form>
              <div class="modal-header">
                <h4 class="modal-title">
                  {{
                    $tc('registerTrainee', traineesNumber, {
                      count: traineesNumber,
                    })
                  }}
                </h4>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click.stop.prevent="hideModal"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="text-center" v-if="showAlert">
                  <div class="alert alert-primary">
                    {{ $t('noTrainingExist') }}
                  </div>
                </div>
                <div class="row" v-if="sessionsFilter.length">
                  <div class="col-12 col-lg-4">
                    {{ $t('selectSession') }}
                  </div>
                  <div class="col-12 mb-4">
                    <div class="post__date mt-2">
                      {{ sessionsFilter.length }} sessions match your request
                    </div>
                  </div>
                  <div
                    class="col-12"
                    v-for="(item, index) in sessionsFilter"
                    :key="index"
                  >
                    <div
                      class="company-block company-block-trainings mb-2"
                      @click.stop.prevent="setSelectedSession(item, index)"
                      :class="{
                        selected:
                          selectedSession && item.id == selectedSession.id,
                      }"
                      :disabled="isAvailble(item)"
                    >
                      <div class="select-training-list">
                        <div class="">
                          {{ item.name || '--' }}
                        </div>
                        <div class="d-flex align-items-center">
                          <span class="mr-1 icon icon-calendar" />{{
                            formatedDate(item.startAt)
                          }}
                          /{{ formatedDate(item.endAt) }}
                        </div>
                        <div class="d-flex align-items-center">
                          <span class="mr-1 icon icon-baloon" />{{
                            item.locationName || '--'
                          }}
                        </div>

                        <div class="d-flex align-items-center">
                          <span
                            :class="
                              item.registrationsCount == item.maximumCapacity
                                ? 'mr-1 icon icon-trainee-danger'
                                : 'mr-1 icon icon-trainee-gray'
                            "
                          />{{ item.registrationsCount }}/
                          {{ item.maximumCapacity }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-12 mb-3" v-if="selectedSession">
                    <div class="text-danger small">
                      {{
                        $t('registrationWarningP1', traineesNumber, {
                          traineesNumber: traineesNumber,
                        })
                      }}
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="d-flex justify-content-between">
                      <div class="">
                        <div class="" :class="alert.type" v-show="alert.on">
                          {{ alert.text }}
                        </div>
                      </div>
                      <button
                        class="btn btn-primary"
                        @click.prevent.stop="registerTrainee"
                        :disabled="isSaving || !selectedSession"
                      >
                        {{
                          $tc('registerTraineeBtn', traineesNumber, {
                            count: traineesNumber,
                          })
                        }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="modal-footer d-flex flex-wrap justify-content-between"
              ></div>
            </form>
          </ValidationObserver>
        </div>
        <div
          v-if="!isLoaded"
          class="py-5 row d-flex justify-content-center align-items-center"
        >
          <div class="col-12">
            <div class="d-flex justify-content-center align-items-center">
              <div class="spinner-border" role="status">
                <span class="sr-only"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import { lazyInput } from 'vue-lazy-input'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'RegistrationTraineeModal',
  directives: {
    lazyInput,
  },
  components: {
    Treeselect,
  },
  data() {
    return {
      isLoaded: false,
      q: '',
      isAllSelected: false,
      sessionsFilter: [],
      trainees: [],
      total: 0,
      selectedTrainingId: null,
      selectedTraining: null,
      courses: [],
      showAlert: false,
      selectedSession: null,
      isSaving: false,
      filter: {},
      alert: {
        on: false,
        type: '',
        text: '',
      },
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
    }
  },
  computed: {
    ...mapFields(['user', 'company', 'establishment']),

    traineesNumber() {
      return this.total
    },
    formatedDate() {
      return function (date) {
        if (this.$moment(date).isValid()) {
          return this.$moment(date).format('DD.MM.YYYY')
        } else return '--'
      }
    },
  },
  mounted() {
    this.$bus.$on('trainee-registration-modal.show', (data) => {
      this.trainees = data.trainees
      this.isAllSelected = data.isAllSelected
      this.total = data.total
      if (this.company && this.company.id) {
        this.$store
          .dispatch('trainees/getSessionsByCompany', {
            companyId: this.company.id,
          })
          .then((response) => {
            if (response.length) {
              this.sessionsFilter = response
            }
            this.isLoaded = true
          })
      } else {
        this.isLoaded = true
      }

      $('#trainee-registration-modal').modal('show')
    })
    this.$bus.$on('hide-trainee-registration-modal', () => {
      $('#trainee-registration-modal').modal('hide')
    })
  },
  methods: {
    isAvailble(session) {
      console.log(
        ' session.registrationsCount == session.maximumCapacity || this.traineesNumber >session.maximumCapacity - session.registrationsCount',
        session.registrationsCount == session.maximumCapacity ||
          this.traineesNumber >
            session.maximumCapacity - session.registrationsCount
      )
      return (
        session.registrationsCount == session.maximumCapacity ||
        this.traineesNumber >
          session.maximumCapacity - session.registrationsCount
      )
    },
    hideModal() {
      this.selectedSession = null
      this.$refs.observer.reset()
      $('#trainee-registration-modal').modal('hide')
    },

    registerTrainee() {
      let trainee = null
      if (this.isAllSelected) {
        trainee = 'All'
      } else {
        trainee = this.trainees
      }
      let data = {
        clientId: this.user.id,
        sessionId: this.selectedSession.id,
        trainees: trainee,
        companyId: this.company ? this.company.id : null,
        establishmentId: this.establishment ? this.establishment.id : null,
        clientWfsa: true,
        language: this.filter?.language ?? null,
        service: this.filter?.service ?? null,
        establishment: this.filter?.establishment ?? null,
        function: this.filter?.function ?? null,
      }
      this.isSaving = true
      this.$store
        .dispatch('trainees/registerTrainee', data)
        .then((response) => {
          this.alert.on = true
          this.alert.text = this.$t('registerTraineeSuccess')
          this.alert.type = 'text-success'
          this.$bus.$emit('trainee-establishment-update')
          setTimeout(() => {
            this.alert.on = false
            this.alert.text = ''
            this.alert.type = ''
            this.hideModal()
          }, 1500)
        })
        .finally(() => {
          this.isSaving = false
        })
    },
    setSelectedSession(session, index) {
      this.selectedSession = session
    },
  },
}
</script>

<style></style>
